import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSmartphone, FiTablet, FiMonitor } = FiIcons;

const ResponsivePrecision = () => {
  const steps = [
    { icon: FiSmartphone, label: "Mobile-first" },
    { icon: FiTablet, label: "Touch-optimised" },
    { icon: FiMonitor, label: "Full-screen clarity" }
  ];

  return (
    <section className="py-20 bg-black border-y border-white/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Built for Real Screens, Not Mockups
          </h2>
          <div className="space-y-6 text-lg text-white/60 mb-12">
            <p>Most websites are designed on a laptop and simply ‘shrunk’ for mobile.</p>
            <p className="text-white font-medium">These pages are engineered for real behaviour:</p>
            <ul className="space-y-4 max-w-lg mx-auto text-left list-disc pl-5">
              <li>On your phone, they behave like a mobile app</li>
              <li>On a tablet, they adapt for touch and readability</li>
              <li>On desktop, they expand for clarity and impact</li>
            </ul>
            <p>That is why the demo you just opened reshapes itself to your screen.</p>
            <p className="text-blue-400 font-bold">Your customers are not all on the same device. Your website should not behave like they are.</p>
          </div>

          <div className="flex justify-center gap-12">
            {steps.map((step, i) => (
              <div key={i} className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center border border-white/10">
                  <SafeIcon icon={step.icon} className="text-blue-400 w-6 h-6" />
                </div>
                <span className="text-[10px] uppercase tracking-widest text-white/40 font-bold">{step.label}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ResponsivePrecision;